<template>
  <main>
    <main-cards> </main-cards>
  </main>
</template>
<script>
import MainCards from "./MainCards.vue";
export default {
  components: {
    MainCards,
  },
};
</script>
<style lang="scss" scoped>
main {
  background-image: url("https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Image_created_with_a_mobile_phone.png/1200px-Image_created_with_a_mobile_phone.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: calc(100vh - 61.2px);
}
</style>
